import React, { UIEvent, createContext, useState } from 'react';
import SideNavBar from '../SideNavBar';
import Player from '../Player';
import { Outlet } from 'react-router-dom';
import Card from '../Card';
import LibraryBar from '../LibraryBar';
import TopNavBar from '../TopNavBar';

export const ScrolledContext = createContext(0);

const PageWrapper = () => {
  const [scrolled, setScrolled] = useState(0);

  const handleScroll = (event: UIEvent<HTMLElement>) => {
    setScrolled(event.currentTarget.scrollTop);
  };

  return (
    <div className="h-screen max-h-screen min-h-screen bg-theme-black grid grid-cols-theme-layout-sm-tablet-cols lg:grid-cols-theme-layout-tablet-cols xl:grid-cols-theme-layout-desktop-cols grid-rows-theme-layout-desktop-rows gap-2">
      <div className="w-theme-nav-bar-width min-h-0 pl-2 pt-2">
        <SideNavBar />
      </div>
      <div className=" min-h-0 min-w-0 row-span-2 pt-2 pr-2">
        <Card className=" w-full h-full text-theme-white overflow-hidden">
          <div
            className="max-h-full h-full relative scrollable"
            onScroll={handleScroll}
          >
            <TopNavBar />
            <ScrolledContext.Provider value={scrolled}>
              <Outlet />
            </ScrolledContext.Provider>
          </div>
        </Card>
      </div>
      <div className=" min-h-0 pl-2">
        <LibraryBar />
      </div>
      <div className=" col-span-2">
        <Player />
      </div>
    </div>
  );
};

export default PageWrapper;
